export const GET_ALL_TASKS_REQUEST = "GET_ALL_TASKS_REQUEST";
export const GET_ALL_TASKS_SUCCESS = "GET_ALL_TASKS_SUCCESS";
export const GET_ALL_TASKS_FAILURE = "GET_ALL_TASKS_FAILURE";
export const SET_SELECTED_TASK_FOR_LAUNCH = "SET_SELECTED_TASK_FOR_LAUNCH";
export const GET_TASK_DETAILS_REQUEST = "GET_TASK_DETAILS_REQUEST";
export const GET_TASK_DETAILS_SUCCESS = "GET_TASK_DETAILS_SUCCESS";
export const GET_TASK_DETAILS_FAILURE = "GET_TASK_DETAILS_FAILURE";
export const CLEAR_SELECTED_TASK = "CLEAR_SELECTED_TASK";
export const CLEAR_ADMIN_TASKS_DATA = "CLEAR_ADMIN_TASKS_DATA";
